// Botón «?» abajo a la derecha: chat para preguntar cómo se hace cada cosa en el panel.
import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { httpsCallable } from 'firebase/functions';
import { functions } from './firebase';

const IDEAS = ['¿Cómo subo los recordatorios de vacunas?', '¿Cómo conecto el WhatsApp?', '¿Cómo mando las facturas a la gestoría?', '¿Cómo invito a alguien del equipo?'];

// Texto con enlaces [Ir a…](/ruta) → botones que llevan a la pantalla
function Texto({ t, ir }) {
  const partes = String(t).split(/(\[[^\]]+\]\(\/[^)\s]*\))/g);
  return partes.map((p, i) => {
    const m = p.match(/^\[([^\]]+)\]\((\/[^)\s]*)\)$/);
    if (m) return <button key={i} className="ay-ir" onClick={() => ir(m[2])}>{m[1]} →</button>;
    return <span key={i}>{p.replace(/\*\*([^*]+)\*\*/g, '$1')}</span>;
  });
}

export default function Ayuda() {
  const [abierto, setAbierto] = useState(false);
  const [h, setH] = useState([]);
  const [t, setT] = useState('');
  const [pensando, setPensando] = useState(false);
  const fin = useRef(null);
  const nav = useNavigate();
  useEffect(() => { fin.current?.scrollIntoView({ block: 'nearest' }); }, [h, pensando, abierto]);
  const ir = (ruta) => { nav(ruta); if (window.innerWidth < 760) setAbierto(false); };
  const enviar = async (x = t) => {
    if (!x.trim() || pensando) return;
    const nh = [...h, { de: 'yo', texto: x.trim() }];
    setH(nh); setT(''); setPensando(true);
    try { const { data } = await httpsCallable(functions, 'ayudaPanel')({ historial: nh }); setH([...nh, { de: 'ayuda', texto: data.respuesta }]); }
    catch (e) { setH([...nh, { de: 'ayuda', texto: `No he podido contestar (${e.message}). Escríbenos a info@vetpanel.es.` }]); }
    setPensando(false);
  };
  return (
    <>
      {abierto && (
        <div className="ay" role="dialog" aria-label="Ayuda">
          <div className="ay-cab">
            <div><b>¿Cómo se hace…?</b><small>Pregunta lo que quieras sobre el panel</small></div>
            <button className="fx-x" onClick={() => setAbierto(false)} aria-label="Cerrar">×</button>
          </div>
          <div className="ay-msgs">
            {!h.length && (
              <div className="ay-ideas">
                {IDEAS.map((x) => <button key={x} onClick={() => enviar(x)}>{x}</button>)}
              </div>
            )}
            {h.map((m, i) => <div key={i} className={`ay-m ${m.de}`}>{m.de === 'ayuda' ? <Texto t={m.texto} ir={ir} /> : m.texto}</div>)}
            {pensando && <div className="ay-m ayuda cf-escribe"><i /><i /><i /></div>}
            <div ref={fin} />
          </div>
          <form className="ay-escribir" onSubmit={(e) => { e.preventDefault(); enviar(); }}>
            <input value={t} onChange={(e) => setT(e.target.value)} placeholder="Escribe tu pregunta…" autoFocus />
            <button className="btn" disabled={!t.trim() || pensando}>Enviar</button>
          </form>
        </div>
      )}
      <button className={`ay-boton${abierto ? ' on' : ''}`} onClick={() => setAbierto(!abierto)} aria-label={abierto ? 'Cerrar la ayuda' : 'Preguntar'} title="Pregunta cómo se hace algo o tus cifras">
        {abierto
          ? <svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" /></svg>
          : <><svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true"><path d="M4 5.5A2.5 2.5 0 0 1 6.5 3h11A2.5 2.5 0 0 1 20 5.5v8a2.5 2.5 0 0 1-2.5 2.5H10l-4.2 3.6c-.5.4-1.3.1-1.3-.6V16A2.5 2.5 0 0 1 4 13.5z" fill="currentColor" /><circle cx="8.5" cy="9.5" r="1.2" fill="#1c1930" /><circle cx="12" cy="9.5" r="1.2" fill="#1c1930" /><circle cx="15.5" cy="9.5" r="1.2" fill="#1c1930" /></svg><span className="ay-texto">Pregunta</span></>}
      </button>
    </>
  );
}
